/** @format */
import { css } from 'styled-components';

const baseStyles = () => {
    const linkPadding = '0.8rem';

    return css`
        .heading {
            margin: 0;
        }

        .link-wrapper {
            margin: -${linkPadding};
            border-radius: 0.8rem;
            width: calc(100% - ${linkPadding});
        }

        .link-container {
            padding: ${linkPadding};

            display: flex;
            align-items: center;
            gap: 0.8rem;
            width: 100%;

            &:hover {
                svg {
                    fill: var(--colors-text-accent);
                }
            }
        }

        .chevron {
            width: 1.6rem;
            fill: var(--colors-text-secondary);
        }
    `;
};

export const styles = () => css`
    ${baseStyles()}
`;
